













































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import BannerTable from "@/admin/components/partners/BannerTable.vue";
import DeleteBannerModal from "@/admin/components/partners/DeleteBannerModal.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import type { PartnerBanner, UpdatePartnerBannerOrderRequest } from "@/shared/types";
import { useBannerStore } from "@/shared/store/banner";

type MoveDirection = "up" | "down";

@Component({
  components: {
    BannerTable,
    DeleteBannerModal
  }
})
export default class CustomBanner extends Vue {
  @Prop() partnerId: number;
  @Prop() copyBannerInCustom: { type: () => void, default: null };

  notifierStore = useNotifierStore();
  userStore = useUserStore();
  bannerStore = useBannerStore();

  loading = true;
  isEditing = false;
  currentBanners = [];

  private originalBanners: PartnerBanner[] | null = null;

  mounted () {
    this.loadCustomBanners();
  }

  loadCustomBanners () {
    this.bannerStore.getCustomPartnerBanners(this.partnerId).then(() => {
      this.resetCurrentBanners();
    });
  }

  @Watch("partnerId")
  onPartnerIdChange () {
    this.loadCustomBanners();
  }

  get isLoading () {
    return !this.bannerStore.isLoaded;
  }

  startEdit () {
    this.originalBanners = this.currentBanners.map(banner => ({ ...banner }));
    this.isEditing = true;
  }

  async saveOrder () {
    const req: UpdatePartnerBannerOrderRequest = {
      banners: this.currentBanners.map(({bannerId, partnerId, carouselOrder}) => ({
        bannerId,
        carouselOrder: Number(carouselOrder),
      }))
    };

    this.bannerStore.updatePartnerBannerOrder(
        Number(this.partnerId),
        req
    ).then(() => {
      this.resetCurrentBanners();
      this.isEditing = false;
      this.originalBanners = null;
    });
  }

  cancelEdit () {
    this.resetCurrentBanners();
    this.isEditing = false;
    this.originalBanners = null;
  }

  resetCurrentBanners () {
    this.currentBanners = this.bannerStore.customBanners;
  }

  openEditBanner (banner?: PartnerBanner) {
    this.$emit("edit", banner);
  }

  moveBanner (banner: PartnerBanner, direction: MoveDirection) {
    if (!this.isEditing) return;

    const delta = direction === "up" ? -1 : 1;
    const currentOrder = banner.carouselOrder;
    const targetOrder = currentOrder + delta;

    const minOrder = 1;
    const maxOrder = this.currentBanners.length;
    if (targetOrder < minOrder || targetOrder > maxOrder) return;

    const adjacentBanner = this.currentBanners.find(banner => banner.carouselOrder === targetOrder);
    if (!adjacentBanner) return;

    const updated = this.currentBanners.map(banner => {
      if (banner.carouselOrder === currentOrder) return { ...banner, carouselOrder: targetOrder };
      if (banner.carouselOrder === targetOrder) return { ...banner, carouselOrder: currentOrder };
      return banner;
    });

    this.currentBanners = updated.sort((a, b) => a.carouselOrder - b.carouselOrder);
  }

  moveBannerUp (banner: PartnerBanner) {
    this.moveBanner(banner, "up");
  }

  moveBannerDown (banner: PartnerBanner) {
    this.moveBanner(banner, "down");
  }
}
